import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const ValidationCheckContent = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: 67px 1fr;
  grid-column-gap: 20px;
  align-items: center;
`;

export const ValidationCheckIcon = styled.div`
  width: 67px;
  height: 67px;
  border-radius: 16px;
  background: ${colors.grayLight};
  display: flex;
  align-items: center;
  justify-content: center;
`;
